import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Edit Tote',
    id: 'qvHBwC',
    description: 'Title of the modal',
  },
  description: {
    defaultMessage: 'Update the tote name and barcode.',
    id: 'bm2mGN',
    description: 'Description of the modal',
  },
  toteNameLabel: {
    defaultMessage: 'Tote Name',
    id: 'Yfcl0V',
    description: 'Label for the tote name input field',
  },
  toteUpdatedTitle: {
    defaultMessage: 'Success!',
    id: '4p6whC',
    description: 'Title of the success message when a tote is updated',
  },
  toteUpdatedMessage: {
    defaultMessage: 'Tote updated successfully.',
    id: 'gTyWE/',
    description: 'Message displayed when a tote is successfully updated',
  },
  barcodeLabel: {
    defaultMessage: 'Barcode',
    id: 'o3Jk1E',
    description: 'Label for the barcode input field',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    id: 'g33k9T',
    description: 'Text for the cancel button',
  },
  saveButton: {
    defaultMessage: 'Save',
    id: 'OBF1oa',
    description: 'Text for the save button',
  },
});
